import React, { useEffect, useMemo, useState } from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { useWidgetGridColumns } from "./useWidgetGridColumns";

interface Props {
  cdWidget?: string;
  searchData?: any;
}

// Purchase detail for sn_sys_widget_012. data[0] = 거래처별 3개월 구매금액, 미입고금액.
// 컬럼 정의는 sys_widgetgridcolumn (grid1).
const SnSysWidget01201: React.FC<Props> = ({ cdWidget, searchData }) => {
  const { userInfo } = global();
  const cdFirm = userInfo.cd_firm || "";
  const getColumns = useWidgetGridColumns(cdWidget);
  // 일반 화면처럼 컬럼을 먼저 받고 조회한다. (먼저 조회하면 컬럼 생성 때 합계 행이 초기화됨)
  const columnsReady = getColumns("grid1").length > 0;
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any[]>([]);

  const queryParams = useMemo(
    () => ({
      cd_firm: cdFirm,
      dt: searchData?.dt,
    }),
    [cdFirm, searchData?.dt]
  );

  useEffect(() => {
    if (!columnsReady) return;

    const fetchData = async () => {
      setLoading(true);

      try {
        const data: any = await fnGetDataSet({
          id: "sn_sys_widget_012_02",
          params: queryParams,
        });

        setRows(data?.[0] || []);
      } catch (error) {
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [queryParams, columnsReady]);

  return (
    <div className="relative flex h-full min-h-0 w-full min-w-0 flex-col p-3">
      <div className="min-h-0 w-full min-w-0 flex-1">
        {getColumns("grid1").length > 0 && (
          <SnGrid
            columnConfig={getColumns("grid1")}
            rowData={rows}
            etcProps={{
              title: "구매현황 상세",
              rowSelection: "single",
              isEditable: false,
              disableColumnSetting: true,
            }}
          />
        )}
      </div>

      {loading && (
        <div className="absolute inset-0 flex items-center justify-center rounded-b-lg bg-white/70 text-sm text-slate-600">
          Loading...
        </div>
      )}
    </div>
  );
};

export default SnSysWidget01201;
